import useQuery from './useQuery';

/** M9 (#160–#161): subscription + seats + plans + invoices for a seller.
 * Owner only — the API 403s other roles, so callers gate `enabled`. */
function useBillingQuery(sellerId, params) {
  return useQuery(`/sellers/${sellerId}/billing/`, {
    enabled: Boolean(sellerId),
    staleTime: 30 * 1000,
    ...params,
  });
}

export default useBillingQuery;
